import React from 'react';
import { Storefront } from '@phosphor-icons/react';

import { Icon } from '../../design-system/components/Icon';

import { MarketShell } from '../../design-system/components/shells';
import { Button, PageHeader, Tabs } from '../../design-system/components/desktop';
import { ConsoleStack } from '../../design-system/patterns/console';
import { BUYER_DASHBOARD_TABS } from '../SellerDashboard/SellerDashboard.view';

import '../Dashboard/dashboard.css';

/**
 * `/dashboard` for a buyer, the view. Pure.
 *
 * ONE TAB BAR, AND IT IS A REAL ONE. A buyer has no mode to choose, so there is
 * no `Segmented` here: Collection and Order history are two panels of one
 * screen and that is exactly what `Tabs` is for. The tab ids and labels are
 * imported from the seller view rather than re-declared, because a seller in
 * buyer mode and a buyer see the same two panels and a second copy of that list
 * is a second thing to drift.
 *
 * MarketShell, not ConsoleShell. This is still the managing side of the split
 * in `README.md` section 6 — a buyer OWNS their collection and their order
 * history, and both panels are tables for that reason — but managing does not
 * mean a separate application. The console's left sidebar made the dashboard
 * feel like somewhere you left Sleevr to go to, when a buyer moves between the
 * marketplace and their collection constantly. Same chrome as the rest of the
 * app, and Dashboard is a link in the primary nav.
 */
export function BuyerDashboardView({
  tab = 'saved',
  onTabChange = () => {},
  panel = null,
  onExploreMarketplace,
  stats = null,
}) {
  return (
    <MarketShell
      title="Dashboard"
      breadcrumbs={[{ label: 'Dashboard' }]}
      showSearch={false}
      activeNav="dashboard"
    >
      <ConsoleStack>
        <PageHeader
          title="Dashboard"
          sub="What you have saved and what you have bought."
          actions={
            onExploreMarketplace ? (
              <Button onClick={onExploreMarketplace}>
                <Icon as={Storefront} />
                Explore marketplace
              </Button>
            ) : null
          }
        />

        {/* The buyer's numbers, in the same slot the seller's KPI band takes.
            A buyer used to land straight on a table with nothing above it. */}
        {stats}

        <div>
          <Tabs
            tabs={BUYER_DASHBOARD_TABS}
            value={tab}
            onChange={onTabChange}
            label="Buyer dashboard sections"
          />
          <div className="dsa-dash__panel">{panel}</div>
        </div>
      </ConsoleStack>
    </MarketShell>
  );
}

export default BuyerDashboardView;
